export default __webpack_public_path__ + "static/media/files-o.d934634f.svg";